<div class="flex flex-col lg:flex-row lg:justify-between space-y-6 lg:space-y-0 items-start lg:items-center">
  <img alt="Atlas Copco logo" height="80" ngSrc="images/logo.png" priority width="250" />
  <h1 class="text-4xl font-semibold">Abacus - {{ category() ?? '' }} comparison report</h1>
</div>
